import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;

const DISMISS_DAYS = 7;
const isDismissed = () => {
  const v = localStorage.getItem("orec_install_dismissed");
  if (!v) return false;
  const at = Number(v);
  if (!at) {
    localStorage.removeItem("orec_install_dismissed");
    return false;
  }
  return Date.now() - at < DISMISS_DAYS * 86400000;
};

export const InstallBanner = () => {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (isDismissed() || isStandalone()) return;
    if (!/android|iphone|ipad|ipod/i.test(navigator.userAgent)) return;
    if (isIos()) {
      setIos(true);
      setShow(true);
      return;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const dismiss = () => {
    localStorage.setItem("orec_install_dismissed", String(Date.now()));
    setShow(false);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    dismiss();
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 z-[70] md:hidden" data-testid="install-banner">
      <div className="silk-card rounded-lg p-4 flex items-center gap-3 shadow-xl">
        <img src="/orec-emblem.png" alt="" className="w-10 h-10 rounded-full shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-foreground">Add O.R.E.C to your home screen</p>
          <p className="text-xs text-muted-foreground">
            {ios ? "Tap Share, then 'Add to Home Screen'" : "Get the app feel — one tap, no download"}
          </p>
        </div>
        {!ios && (
          <Button size="sm" className="rounded-full px-4 shrink-0" onClick={install} data-testid="install-banner-install">
            Install
          </Button>
        )}
        <button onClick={dismiss} className="text-muted-foreground shrink-0" data-testid="install-banner-dismiss" aria-label="Dismiss">
          <X size={16} />
        </button>
      </div>
    </div>
  );
};
